import React from 'react';
import { GraySection, Title1, InfoText } from './styled'

function GraySec() {
  return (
    <GraySection>
      <Title1><span>People are Our Greatest Asset</span></Title1>
      <InfoText >If you would love a job opportunity and learn a trade or showcase your existing</InfoText>
      <InfoText >talents, submit your resume and/or your application today!</InfoText>
    </GraySection>
  )
}

export default GraySec
